import { AppState } from 'types';
import { logger, saveState } from 'helpers';

export type Dispatch = React.Dispatch<Action>;

type Action = [(state: AppState, payload: Partial<AppState>) => AppState, Partial<AppState>];

export function Reducer(state: AppState, [action, payload]: Action) {
	const newState = action(state, payload);
	logger({ action, payload, state, newState });
	saveState(newState);
	return newState;
}
